import { LocationDisplay } from 'app/agriculture/routes/Devices/DeviceDetails/components/display/LocationDisplay';
import { SuspenseWrapper } from 'app/agriculture/components/SuspenseWrapper/SuspenseWrapper';
import { LocationDisplaySkeleton } from 'app/agriculture/routes/Devices/DeviceDetails/components/display/LocationDisplaySkeleton';

export function PersonalLocatorBeaconContent() {
    return <LocationDisplay />;
}
